import SettingsIcon from "@mui/icons-material/Settings";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import SearchIcon from "@mui/icons-material/Search";
import { Button, FormControlLabel, Switch, Tooltip, TextField, InputAdornment, Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import _ from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../AppContext";
import HelmetMeta from "../../components/HelmetMeta";
import { showReservationPrompt } from "../../components/ReservationPromptDialog";
import GroupList from "../../sections/restaurant/items/GroupList";
import SubGroupList from "../../sections/restaurant/items/SubGroupList";
import { PosContext } from "../../shared/PosContext";
import {
    useDeleteDoctype,
    useSaveUserSettings,
} from "../../shared/hooks/useFrappeDoctype";
import {
    usePushItemToOrderData,
    useRemoveItemFromTableOrderData,
} from "../../shared/hooks/useTableOrderItemsData";
import {
    useAddNewOrder,
    useCreateTableOrder,
    usePushOrderItems,
    useTableOrdersLazy,
} from "../../shared/hooks/useTableOrdersData";
import {
    cloneAddOn,
    defaultErrorToast,
    isJsonString,
    randomId,
} from "../../utils/floorUtils";
import AddItemWidget from "../Selling/Widgets/AddItemWidget";
import WidgetsDialogs from "../Widgets/WidgetsDialogs";
import OrderCart from "./components/OrderCart";
import PosItemList from "./components/PosItemList";
import TakeawayOrderTabs from "./components/TakeawayOrderTabs";
import { useStyles } from "./styles";
const PosPage = () => {
    const {
        changeSelectedTable,
        selectedTable,
        isAppLoading,
        selectedOrder,
        setSelectedOrder,
        setOrders,
        orderItems,
        getMenuItem,
        customerContext,
        addressContext,
        menuItems,
        selectedFloor,
        setTakeawayOrder,
        addonsItems,
        groupedItems,
        refetchTablesData,
    } = useContext(PosContext);

    const {
        isTabsPos,
        userMenuSettings,
        setUserMenuSettings,
        elevatedPrivileges,
        restaurantSettings,
    } = useContext(AppContext);

    const navigate = useNavigate();

    const { tableName, orderName } = useParams();

    const { mutate: deleteDoc } = useDeleteDoctype();

    const isTakeaway = useMemo(() => {
        return tableName && tableName === "takeaway" ? true : false;
    }, [tableName]);

    const [tmpOrderItems, setTmpOrderItems] = useState([]);

    const [selectedCustomer, setSelectedCustomer] = customerContext;
    const [selectedAddress, setSelectedAddress] = addressContext;

    const classes = useStyles();

    const [toCloseTable, setToCloseTable] = useState(null);

    // const [selectedOrder, setSelectedOrder] = useState(null);

    const [category, setCategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subCategory, setSubCategory] = useState(null);

    const [addItemOpen, setAddItemOpen] = useState(false);
    const [addedItem, setAddedItem] = useState(null);

    const [editOrderItemOpen, setEditOrderItemOpen] = useState(false);
    const [editedItem, setEditedItem] = useState(null);
    const [editedOrderItem, setEditedOrderItem] = useState(null);
    const [menuItems1, setMenuItems1] = useState(null);

    const createOrderMutation = useCreateTableOrder(); //room, tableFormData
    const pushItemToOrderMutation = usePushItemToOrderData(); //room, tableFormData
    const removeOrderItemMutation = useRemoveItemFromTableOrderData();

    const [items, setItems] = useState([]);
    const [savedItems, setSavedItems] = useState([]);

    const { data: toCloseTableOrders, refetch: fetchCloseTableOrders } =
        useTableOrdersLazy(toCloseTable?.name || null);

    const [widgetDialogTable, setWidgetDialogTable] = useState(null);
    const [widgetsDialogsOpen, setWidgetsDialogsOpen] = useState(false);

    const [isDragDropMode, setIsDragDropMode] = useState(false);
    const [isQuickAddMode, setIsQuickAddMode] = useState(false);
    const [searchText, setSearchText] = useState("");

    const saveUserSettings = useSaveUserSettings();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (isTakeaway) {
            if (selectedOrder?.customer) {
                setSelectedCustomer(selectedOrder.customer);
            } else {
                setSelectedCustomer("takeaway-customer");
            }
        }
    }, [isTakeaway, selectedOrder]);

    useEffect(() => {
        if (!isAppLoading) {
            if (tableName === "takeaway") {
                setTakeawayOrder(orderName);
            } else {
                changeSelectedTable(tableName, orderName);
            }
        }
    }, [isAppLoading, tableName, orderName]);

    useEffect(() => {
        if (tmpOrderItems.length > 0) {
            setItems(tmpOrderItems);
        } else {
            setItems([]);
        }
    }, [tmpOrderItems]);

    useEffect(() => {
        if (toCloseTable) fetchCloseTableOrders();
    }, [toCloseTable]);

    useEffect(() => {
        //-TODO NEW CHANGES
        if (toCloseTableOrders && toCloseTableOrders.length > 0) {
            setWidgetDialogTable(toCloseTable);
            setWidgetsDialogsOpen(true);
        } else {
            setWidgetDialogTable(null);
            setWidgetsDialogsOpen(false);
        }
    }, [toCloseTableOrders]);

    const updateOrderItems = (_orderItems) => {
        const _items = _orderItems || orderItems;
        const cartItems = [];
        _items
            .filter((i) => !i.parent_item || i.parent_item == "NULL")
            .forEach((i) => {
                const menuItem = getMenuItem(i.item_code);
                if (menuItem) {
                    const itemAddons = [];
                    const addonsArray = i.addons ? JSON.parse(i.addons) : [];

                    if (addonsArray && addonsArray.length > 0) {
                        addonsArray.map((ad) => {
                            if (typeof ad === "string") {
                                itemAddons.push(
                                    addonsItems.find(
                                        (entry) => entry.item_code === ad
                                    )
                                );
                            } else if (typeof ad === "object") {
                                itemAddons.push({
                                    ...addonsItems.find(
                                        (entry) =>
                                            entry.item_code === ad.item_code
                                    ),
                                    standard_rate: ad.standard_rate,
                                });
                            }
                        });
                    }
                    cartItems.push({
                        item: {
                            ...i,
                            cover: menuItem.cover,
                            standard_rate: menuItem.standard_rate,
                        },
                        addons: itemAddons,
                        qty: i.qty,
                        entry_name: menuItem.identifier,
                    });
                }
            });

        setSavedItems(cartItems);
    };

    useEffect(() => {
        if (orderItems && orderItems.length > 0 && addonsItems) {
            updateOrderItems();
        } else {
            setItems([]);
        }
    }, [orderItems, addonsItems]);

    useEffect(() => {
        if (isTakeaway) {
            if (!orderName) {
                setSavedItems([]);
            }
            setTmpOrderItems([]);
            setItems([]);
        }
    }, [isTakeaway, orderName]);

    useEffect(() => {
        if (editedOrderItem) {
            let itemInOrder;
            if (menuItems1 && menuItems1.length > 0)
                itemInOrder = _.find(menuItems1, {
                    item_code: editedOrderItem.item_code,
                });

            if (itemInOrder) {
                setEditedItem(itemInOrder);
            }
        }
    }, [editedOrderItem]);

    // Load quick add mode from user settings
    useEffect(() => {
        if (userMenuSettings && userMenuSettings.quick_add_mode !== undefined) {
            setIsQuickAddMode(userMenuSettings.quick_add_mode);
        }
    }, [userMenuSettings]);

    // Save quick add mode when it changes
    const handleQuickAddModeChange = (newMode) => {
        setIsQuickAddMode(newMode);

        if (userMenuSettings) {
            const _userSettings = { ...userMenuSettings };
            _userSettings.quick_add_mode = newMode;

            // Update AppContext immediately for UI responsiveness
            setUserMenuSettings(_userSettings);

            saveUserSettings.mutate(
                {
                    doctype: "menu_settings",
                    user_settings: _userSettings,
                },
                {
                    onSuccess: () => {
                        // Invalidate the cache so fresh data is fetched on next page load
                        queryClient.invalidateQueries([
                            "GetUserSettings",
                            "menu_settings",
                        ]);
                        console.log("Quick add mode saved!");
                    },
                }
            );
        }
    };

    /**
     * Quick add item to cart without opening dialog
     * @param item
     */
    const quickAddItem = (item) => {
        // Check if item already exists in tmpOrderItems with no notes/addons
        const existingItemIndex = tmpOrderItems.findIndex(
            (orderItem) =>
                orderItem.item.item_code === item.item_code &&
                (!orderItem.notes || orderItem.notes === "") &&
                (!orderItem.addons || orderItem.addons.length === 0)
        );

        if (existingItemIndex !== -1) {
            // Item exists with no notes/addons, increment quantity
            setTmpOrderItems((prevState) => {
                const updatedItems = [...prevState];
                updatedItems[existingItemIndex] = {
                    ...updatedItems[existingItemIndex],
                    qty: updatedItems[existingItemIndex].qty + 1,
                };
                return updatedItems;
            });
        } else {
            // Item doesn't exist or has notes/addons, add new item
            const clonedItem = {
                item: {
                    ...item,
                    qty: 1,
                    notes: "",
                },
                qty: 1,
                addons: [],
                notes: "",
                entry_name: randomId(5),
            };

            addItemToOrder(clonedItem);
        }
    };

    /**
     * Pushes item to selected order.
     * @param item
     */
    const onItemClick = (item) => {
        const itemBudnle = item.menu_item_bundle
            ? JSON.parse(item.menu_item_bundle)
            : null;
        const skipQuickAdd =
            itemBudnle &&
            itemBudnle.categories &&
            itemBudnle.categories.length > 0;
        if (isQuickAddMode && !skipQuickAdd) {
            quickAddItem(item);
        } else {
            setAddedItem(item);
            setAddItemOpen(true);
        }
    };

    const handleAddItemClose = () => {
        setAddItemOpen(false);
        setEditOrderItemOpen(false);
        setEditedItem(null);
        setEditedOrderItem(null);
    };

    const handleInvoiceClosed = () => {
        if (isTakeaway) {
            refetchTablesData().then((res) => {
                const orders = res.data.message.takeaway?.orders;

                if (orders && orders[orderName]) {
                    const newItems = orders[orderName].entry_items.map((i) => {
                        const menuItem = getMenuItem(i.item_code);
                        if (menuItem) {
                            return {
                                item: {
                                    ...i,
                                    cover: menuItem.cover,
                                    standard_rate: menuItem.standard_rate,
                                },
                                addons: i.addons
                                    ? isJsonString(i.addons)
                                        ? JSON.parse(i.addons)
                                        : i.addons
                                    : [],
                                qty: i.qty,
                                entry_name: i.item_code,
                            };
                        }
                    });

                    setSavedItems(newItems);
                    handleCloseDialog();
                } else {
                    navigate("/tables");
                }
            });
        } else {
            navigate("/tables");
        }
    };

    const addItemToOrder = (item) => {
        setTmpOrderItems((prevState) => [...prevState, item]);
    };

    const handleUpdateItem = (item, isNew) => {
        const itemToUpdate = { ...item };

        let updatedAddons = [];
        itemToUpdate.addons.forEach((addon) => {
            // addon can be a string (item_code) or an object { item_code, standard_rate }
            const addonCode =
                typeof addon === "string" ? addon : addon.item_code;
            const overrideRate =
                typeof addon === "object" && addon?.standard_rate != null
                    ? Number(addon.standard_rate)
                    : null;

            let addonItem = _.find(
                addonsItems,
                (it) => it.item_code === addonCode
            );
            if (!addonItem) {
                addonItem = {
                    item_code: addonCode,
                    standard_rate: overrideRate || 0,
                };
            }

            updatedAddons.push(
                cloneAddOn(
                    addonItem,
                    itemToUpdate.qty,
                    itemToUpdate.identifier,
                    overrideRate
                )
            );
        });
        itemToUpdate.addons = updatedAddons.length > 0 ? updatedAddons : [];

        const currentOrders = [...tmpOrderItems];
        const updatedOrders = currentOrders.map((i) => {
            if (i.entry_name === item.entry_name) {
                return itemToUpdate;
            } else {
                return i;
            }
        });

        setTmpOrderItems(updatedOrders);
    };
    const handleAddItem = (item, qty, addons, notes) => {
        // onItemClick(item, qty);

        let clonedItem = {};
        clonedItem.item = {
            ...item,
            ["notes"]: notes,
            ["qty"]: qty,
        };

        if (qty) clonedItem.qty = qty;

        if (notes && notes.length > 0) {
            clonedItem.notes = notes;
        }

        let addonsToSave = [];
        if (addons) {
            addons.forEach((aItem) => {
                // aItem can be a string (item_code) or object { item_code, standard_rate }
                const addonCode =
                    typeof aItem === "string" ? aItem : aItem.item_code;
                const overrideRate =
                    typeof aItem === "object" && aItem?.standard_rate != null
                        ? Number(aItem.standard_rate)
                        : null;
                let addonItem = _.find(
                    addonsItems,
                    (it) => it.item_code === addonCode
                );
                if (!addonItem) {
                    addonItem = {
                        item_code: addonCode,
                        standard_rate: overrideRate || 0,
                    };
                }
                addonsToSave.push(
                    cloneAddOn(
                        addonItem,
                        clonedItem.qty,
                        clonedItem.identifier,
                        overrideRate
                    )
                );
            });
            clonedItem.addons = addonsToSave.length > 0 ? addonsToSave : [];

            clonedItem.entry_name = randomId(5);

            if (selectedOrder && selectedOrder.name) {
                addItemToOrder({
                    ...clonedItem,
                    ["notes"]: notes,
                    ["qty"]: qty,
                });
            } else {
                addItemToOrder({
                    ...clonedItem,
                    ["notes"]: notes,
                    ["qty"]: qty,
                });
                // addItemToOrder(clonedItem);
            }

            setAddItemOpen(false);
            setEditOrderItemOpen(false);
        }
    };

    const onGroupClicked = (group) => {
        if (group && !group.name) {
            setCategory(null);
            setSelectedCategory(null);
            setSubCategory(null);
            return;
        }

        setCategory(group);

        // const { id, name, cover } = group;
        setSelectedCategory(group);
        setSubCategory(null);
    };

    const onSubGroupClicked = (subGroup) => {
        if (subGroup && !subGroup.name) {
            setSubCategory(null);
            return;
        }
        setSubCategory(subGroup);
    };

    const handleSelectOrder = (order) => {
        navigate(`/pos/${tableName}/${order.name}`);
    };

    const handleCloseTable = (order, table) => {
        setWidgetDialogTable(table);
        setWidgetsDialogsOpen(true);
    };

    const mutateNewOrder = useAddNewOrder();
    const mutatePushOrderItems = usePushOrderItems();

    const handleSaveToTable = async (table) => {
        const newOrderItems = [];
        tmpOrderItems.map((i) => {
            newOrderItems.push({
                addons: i.addons.map((addon) => ({
                    item_code: addon.item_code,
                    item_name: addon.item_name,
                    name: addon.name,
                    identifier: addon.identifier,
                    rate: addon.rate,
                    standard_rate: addon.rate,
                    qty: addon.qty,
                })),
                qty: i.qty,
                item: i.item.item_code,
                notes: i.notes,
                standard_rate: i.item.standard_rate,
            });
        });

        const rateChanged = [];

        // selectedOrder;

        newOrderItems.map((i) => {
            const menuItem = menuItems.find(
                (item) => item.item_code === i.item
            );
            if (menuItem) {
                if (menuItem.standard_rate !== i.standard_rate) {
                    rateChanged.push({
                        ...i,
                        originalRate: menuItem.standard_rate,
                    });
                }
            }
        });

        if (selectedOrder) {
            setTmpOrderItems([])
            mutatePushOrderItems.mutate(
                {
                    orderItems: newOrderItems,
                    order: selectedOrder,
                    elevatedPrivileges:
                        elevatedPrivileges && rateChanged.length > 0,
                    elevatedText: rateChanged.length > 0 ? "Rate Changed" : "",
                },
                {
                    onSuccess: () => {
                        refetchTablesData().then((res) => {
                            if (isTabsPos) {
                                updateOrderItems(
                                    res.data.message[tableName]?.orders?.[
                                        orderName
                                    ]?.entry_items
                                );

                                setTmpOrderItems([]);
                                setItems([]);
                            }
                        });

                        if (isTabsPos) {
                        } else {
                            navigate("/tables");
                        }
                    },
                    onError: (error) => {
                        defaultErrorToast(error);
                    },
                }
            );
        } else {
            let notes = "";
            if (restaurantSettings?.docs[0]?.mandatory_notes == 1) {
                const notes = await showReservationPrompt({
                    title: "Order Notes",
                    message: "Please enter the notes for this order:",
                    confirmText: "Create Order",
                    cancelText: "Cancel",
                });

                if (!notes) {
                    return;
                }
            }

            mutateNewOrder.mutate(
                {
                    orderItems: newOrderItems,
                    table: selectedTable.name,
                    customer: selectedCustomer,
                    address: selectedAddress,
                    dinners: notes.adults,
                    dinners_children: notes.kids,
                    dinners_infants: notes.babies,
                    notes: notes.notes,
                    elevatedPrivileges:
                        elevatedPrivileges && rateChanged.length > 0,
                    elevatedText: rateChanged.length > 0 ? "Rate Changed" : "",
                },
                {
                    onSuccess: (res) => {
                        if (isTakeaway) {
                            refetchTablesData().then(() => {
                                setTmpOrderItems([]);
                                navigate("/pos/takeaway/" + res.message);
                            });
                        } else {
                            refetchTablesData();
                            navigate("/tables");
                        }
                    },
                    onError: (error) => {
                        defaultErrorToast(error);
                    },
                }
            );
        }
        return;
    };

    const handleCloseDialog = () => {
        setWidgetsDialogsOpen(false);
        setToCloseTable(null);
    };

    const handleItemDelete = (orderItem, props) => {
        setTmpOrderItems((current) =>
            current.filter((item) => item.entry_name !== orderItem.entry_name)
        );
    };

    const [itemDeleting, setItemDeleting] = useState(false);

    const handleSubmittedItemDelete = (orderItem, password, qty, notes, waste) => {
        setItemDeleting(true);

        const removeOrderItemPayload = {
            orderId: selectedOrder.name,
            item: orderItem.item,
        };

        if (elevatedPrivileges) {
            removeOrderItemPayload.masterPassword = password;
        }

        if (qty) {
            removeOrderItemPayload.qty = qty;
        }

        if (waste) {
            removeOrderItemPayload.waste = waste;
        }

        removeOrderItemMutation.mutate(removeOrderItemPayload, {
            onSuccess: () => {
                refetchTablesData();

                // const newSavedItems = savedItems.filter(
                // (i) => i.item.identifier !== orderItem.item.identifier
                // );

                const newSavedItems = [];
                savedItems.forEach((i) => {
                    if (i.item.identifier === orderItem.item.identifier) {
                        if (i.item.qty > qty) {
                            newSavedItems.push({
                                ...i,
                                qty: i.item.qty - qty,
                            });
                        }
                    } else {
                        newSavedItems.push(i);
                    }
                });

                setSavedItems(newSavedItems);

                if (newSavedItems.length === 0) {
                    deleteDoc({
                        doctype: "Table Order",
                        name: selectedOrder.name,
                    });
                    refetchTablesData();
                    navigate("/tables");
                    // setSelectedOrder(null);
                    // setOrders([]);
                }
            },
            onError: (error) => {
                // defaultErrorToast(error);
            },
            onSettled: () => {
                setItemDeleting(false);
            },
        });
    };

    // Define the event handler function
    const handleItemEdit = (orderItem) => {
        setEditedOrderItem(orderItem);
        setAddedItem(orderItem.item);
        setEditOrderItemOpen(true);
    };

    const onItemsLoaded = (items) => {
        setMenuItems1(items);
    };

    return (
        <React.Fragment>
            <div className={classes.NotificationSnackbarIcon}></div>
            <div className={classes.PageWrap}>
                <HelmetMeta title={"POS"} />
                {isTabsPos && <TakeawayOrderTabs />}
                <div
                    className={`${classes.NewOrderPage} ${
                        isTabsPos ? "tabsPos" : ""
                    }`}
                >
                    <div className={classes.Categories}>
                        <div className={"CategoriesList"}>
                            <GroupList
                                onClick={onGroupClicked}
                                isDragDropMode={isDragDropMode}
                            ></GroupList>
                        </div>
                    </div>
                    <div
                        className={`${classes.CategoryView} ${
                            isTabsPos ? "tabsPos" : ""
                        }`}
                    >
                        <Box className={"CategoryView__Header"}>
                            {/* Desktop and Large Tablet Layout - Single Row */}
                            <Box 
                                sx={{
                                    display: { xs: "none", lg: "flex" },
                                    alignItems: "center",
                                    height: "70px",
                                    gap: 2,
                                }}
                            >
                                <Box 
                                    className={"Subcatgories"}
                                    sx={{ 
                                        flex: 2,
                                        minWidth: "350px",
                                        height: "100%",
                                    }}
                                >
                                    <SubGroupList
                                        parentItem={selectedCategory}
                                        onClick={onSubGroupClicked}
                                        isDragDropMode={isDragDropMode}
                                    ></SubGroupList>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        flexShrink: 0,
                                    }}
                                >
                                    <TextField
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        size="small"
                                        placeholder="Search items..."
                                        sx={{ minWidth: 220, maxWidth: 300 }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isQuickAddMode}
                                                onChange={(e) =>
                                                    handleQuickAddModeChange(
                                                        e.target.checked
                                                    )
                                                }
                                                color="primary"
                                            />
                                        }
                                        label="Quick Add"
                                        sx={{
                                            margin: 0,
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                            },
                                        }}
                                    />
                                    <Tooltip
                                        title={
                                            isDragDropMode
                                                ? "Exit Settings Mode"
                                                : "Enter Settings Mode"
                                        }
                                    >
                                        <Button
                                            onClick={() =>
                                                setIsDragDropMode(!isDragDropMode)
                                            }
                                            sx={{
                                                fontSize: "1.5rem",
                                                minWidth: "auto",
                                                padding: "8px",
                                            }}
                                            startIcon={
                                                isDragDropMode ? (
                                                    <SettingsApplicationsRoundedIcon />
                                                ) : (
                                                    <SettingsIcon />
                                                )
                                            }
                                        >
                                            {isDragDropMode ? "" : ""}
                                        </Button>
                                    </Tooltip>
                                </Box>
                            </Box>

                            {/* Mobile and Tablet Layout - Two Rows */}
                            <Box 
                                sx={{
                                    display: { xs: "block", lg: "none" },
                                }}
                            >
                                {/* Controls Row */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1.5,
                                        gap: 1,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <TextField
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        size="small"
                                        placeholder="Search items..."
                                        sx={{ 
                                            minWidth: { xs: 140, sm: 180 },
                                            maxWidth: { xs: 200, sm: 250 },
                                            flexGrow: 1,
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={isQuickAddMode}
                                                    onChange={(e) =>
                                                        handleQuickAddModeChange(
                                                            e.target.checked
                                                        )
                                                    }
                                                    color="primary"
                                                />
                                            }
                                            label="Quick Add"
                                            sx={{
                                                margin: 0,
                                                "& .MuiFormControlLabel-label": {
                                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                                    fontWeight: 500,
                                                },
                                            }}
                                        />
                                        <Tooltip
                                            title={
                                                isDragDropMode
                                                    ? "Exit Settings Mode"
                                                    : "Enter Settings Mode"
                                            }
                                        >
                                            <Button
                                                onClick={() =>
                                                    setIsDragDropMode(!isDragDropMode)
                                                }
                                                sx={{
                                                    fontSize: "1.5rem",
                                                    minWidth: "auto",
                                                    padding: { xs: "6px", sm: "8px" },
                                                }}
                                                startIcon={
                                                    isDragDropMode ? (
                                                        <SettingsApplicationsRoundedIcon />
                                                    ) : (
                                                        <SettingsIcon />
                                                    )
                                                }
                                            >
                                                {isDragDropMode ? "" : ""}
                                            </Button>
                                        </Tooltip>
                                    </Box>
                                </Box>
                                
                                {/* Subcategories Row */}
                                <Box 
                                    className={"Subcatgories"}
                                    sx={{
                                        height: "50px",
                                        width: "100%",
                                    }}
                                >
                                    <SubGroupList
                                        parentItem={selectedCategory}
                                        onClick={onSubGroupClicked}
                                        isDragDropMode={isDragDropMode}
                                    ></SubGroupList>
                                </Box>
                            </Box>
                        </Box>
                        <div
                            className={classes.CategoryViewWrapper}
                            style={{
                                overflowY: "auto",
                                overflowX: "hidden",
                            }}
                        >
                            <PosItemList
                                groupedItems={groupedItems}
                                menuItems={menuItems}
                                onClick={onItemClick}
                                category={category}
                                subCategory={subCategory}
                                onItemsLoaded={onItemsLoaded}
                                isDragDropMode={isDragDropMode}
                                searchText={searchText}
                            ></PosItemList>
                        </div>
                    </div>
                    <div className={classes.Order}>
                        {selectedTable && (
                            <OrderCart
                                selectedOrder={selectedOrder}
                                items={items}
                                savedItems={savedItems}
                                table={selectedTable}
                                handleSaveToTable={handleSaveToTable}
                                handleSelectOrder={handleSelectOrder}
                                handleCloseTable={handleCloseTable}
                                floor={selectedFloor}
                                // isOrderItemsLoading={isOrderItemsLoading}
                                isTakeaway={isTakeaway}
                                onItemEdit={handleItemEdit}
                                onItemDelete={handleItemDelete}
                                onSubmittedItemDelete={
                                    handleSubmittedItemDelete
                                }
                                itemDeleting={itemDeleting}
                            />
                        )}
                    </div>
                </div>
            </div>

            <WidgetsDialogs
                open={widgetsDialogsOpen}
                onClose={handleCloseDialog}
                order={selectedOrder}
                table={widgetDialogTable}
                isTakeaway={isTakeaway}
                onInvoiceClose={handleInvoiceClosed}
            ></WidgetsDialogs>

            <AddItemWidget
                item={addedItem}
                open={addItemOpen || editOrderItemOpen}
                onClose={handleAddItemClose}
                onAddItem={handleAddItem}
                onUpdateItem={handleUpdateItem}
                editedOrderItem={editedOrderItem}
                pushItemWorker={pushItemToOrderMutation}
                readOnly={false}
            />
        </React.Fragment>
    );
};

export default PosPage;
